var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 139,
    viewBox: "0 0 200 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4058_2954)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.801 15.2624H1V138.435H198.801V15.2624Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4914 38.9913H14.2641V62.539H50.4914V38.9913Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5065 38.9913H59.2793V62.539H95.5065V38.9913Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.522 38.9913H104.294V62.539H140.522V38.9913Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.537 38.9913H149.31V62.539H185.537V38.9913Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4914 72.3204H14.2641V95.8681H50.4914V72.3204Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5065 72.3204H59.2793V95.8681H95.5065V72.3204Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.522 72.3204H104.294V95.8681H140.522V72.3204Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.537 72.3204H149.31V95.8681H185.537V72.3204Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4914 105.649H14.2641V129.197H50.4914V105.649Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5065 105.649H59.2793V129.197H95.5065V105.649Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.522 105.649H104.294V129.197H140.522V105.649Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.537 105.649H149.31V129.197H185.537V105.649Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.805 29.7533C55.8062 29.7533 58.2391 27.3204 58.2391 24.3192C58.2391 21.3181 55.8062 18.8851 52.805 18.8851C49.8038 18.8851 47.3709 21.3181 47.3709 24.3192C47.3709 27.3204 49.8038 29.7533 52.805 29.7533Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.649 29.7533C145.65 29.7533 148.083 27.3204 148.083 24.3192C148.083 21.3181 145.65 18.8852 142.649 18.8852C139.648 18.8852 137.215 21.3181 137.215 24.3192C137.215 27.3204 139.648 29.7533 142.649 29.7533Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9786 0.771515H50.6314V25.7683H54.9786V0.771515Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.822 0.771515H140.475V25.7683H144.822V0.771515Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.615 50.7651C175.614 52.7325 174.902 54.633 173.611 56.1176C172.32 57.6023 170.537 58.5712 168.589 58.8463C166.641 59.1215 164.659 58.6845 163.007 57.6156C161.356 56.5466 160.146 54.9176 159.599 53.0278C159.052 51.1379 159.206 49.1143 160.031 47.3286C160.857 45.543 162.299 44.1153 164.093 43.3078C165.887 42.5004 167.913 42.3675 169.797 42.9335C171.681 43.4996 173.297 44.7265 174.349 46.389C175.178 47.6981 175.617 49.2159 175.615 50.7651Z",
    fill: "#F2B400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.349 46.389L166.285 54.4517C165.778 53.667 162.955 50.0204 162.955 50.0204C163.317 49.6547 163.703 49.3138 164.111 49.0001L166.452 52.1221L173.405 45.1691C173.758 45.545 174.074 45.9534 174.349 46.389Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5852 84.0942C85.5833 86.0616 84.8716 87.9621 83.5807 89.4467C82.2898 90.9313 80.5066 91.9003 78.5586 92.1754C76.6106 92.4506 74.6288 92.0136 72.9772 90.9447C71.3256 89.8757 70.1152 88.2467 69.5685 86.3568C69.0217 84.467 69.1753 82.4434 70.001 80.6577C70.8268 78.8721 72.2691 77.4444 74.0631 76.6369C75.8571 75.8295 77.8822 75.6966 79.7664 76.2626C81.6505 76.8287 83.2671 78.0556 84.3191 79.7181C85.1476 81.0272 85.5867 82.545 85.5852 84.0942Z",
    fill: "#F2B400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3191 79.7181L76.2549 87.7808C75.7481 86.9961 72.9244 83.3495 72.9244 83.3495C73.2862 82.9838 73.6724 82.6429 74.0802 82.3292L76.4217 85.4512L83.3748 78.4982C83.7274 78.8741 84.0436 79.2825 84.3191 79.7181Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5701 84.0943C40.5682 86.0616 39.8564 87.9622 38.5656 89.4468C37.2747 90.9314 35.4915 91.9003 33.5435 92.1755C31.5955 92.4507 29.6136 92.0137 27.962 90.9447C26.3104 89.8758 25.1 88.2467 24.5533 86.3569C24.0065 84.467 24.1601 82.4434 24.9858 80.6577C25.8116 78.8721 27.2539 77.4443 29.0479 76.6369C30.842 75.8295 32.8671 75.6966 34.7512 76.2626C36.6354 76.8287 38.252 78.0556 39.304 79.7181C40.1324 81.0272 40.5715 82.545 40.5701 84.0943Z",
    fill: "#F2B400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.304 79.7181L31.2398 87.7808C30.7329 86.9961 27.9092 83.3495 27.9092 83.3495C28.2711 82.9838 28.6573 82.6429 29.0651 82.3292L31.4066 85.4512L38.3596 78.4982C38.7122 78.8741 39.0284 79.2825 39.304 79.7181Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4058_2954"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 199,
    height: 138,
    fill: "white",
    transform: "translate(0.5 0.748688)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.a7fe971e140804209da85cef789bfcf0.svg";
export { ForwardRef as ReactComponent };